import { useSelector } from 'react-redux';

import { isLgScreen } from '@client/helpers/screens';
import { getClientDeviceWidth } from '@client/redux/modules/clientDevice';
import { getCategoryTabId } from '@client/redux/modules/mylounge';
import { CategoryTabIds } from '@shared/constants';

export const useCrossCampaignEntry = () => {
    const width = useSelector(getClientDeviceWidth);
    const categoryTabId = useSelector(getCategoryTabId);

    const lgScreen = isLgScreen(width);

    const isReducedConfusionTab = [
        CategoryTabIds.MEN,
        CategoryTabIds.WOMEN,
        CategoryTabIds.KIDS,
        CategoryTabIds.HOME,
    ].includes(categoryTabId);

    return {
        showCrossCampaignFilterInMobile: isReducedConfusionTab && !lgScreen,
        showCrossCampaignFilterInDesktop: lgScreen,
    };
};
